import { type IThemeContext } from '@/state/Theme';
import Logo from './components/icons/Logo';
import commonColors from '@/state/CommonColors';

const brandTheme: IThemeContext = {
  brandLogo: Logo,
  brandLogoMobile: undefined,
  brandColor: '#ED560E',
  brandName: 'Z',
  brandStationLabelMobile: 'Z Station / Truck stop / Airstop',
  brandStationLabelDesktop:
    'Please enter a Location / station / Truck stop / Airstop',
  colorPalette: [
    // Common colours shared between brands
    ...commonColors,

    // Brand colours specific to Z Energy
    { name: 'orange', value: '#ED560E' },
    { name: 'mid-orange', value: '#FFA13A' },
    { name: 'deep-orange', value: '#B0400A' },
    { name: 'indigo', value: '#1E196A' },
    { name: 'light-indigo', value: '#3129AC' },
    { name: 'deep-indigo', value: '#131045' },
    { name: 'yellow', value: '#FFCB08' },
    { name: 'neutral', value: '#353535' },
    { name: 'error', value: ' #FE0C00' },
  ],
  footerIconColor: '#ED560E',
  colorApplication: {
    bannerLinkGridBackground:
      'linear-gradient(261.59deg,#3129ac -6.6%,#1e196a 79.03%)',
    bannerLinkGridColor: '#ffffff',
  },
};

export default brandTheme;
